module.exports = __webpack_public_path__ + "media/assets/images/signpost-206557d7610a7d0f4f4d090c05827f8f.svg";